// src/components/AllClassesSummaryPane.jsx
// すべての授業のまとめ【2026-09-04】
//
// 授業を1つずつ開かなくても、担当している授業を横並びで見られるようにする。
// 出席率は実施済み・休講でない回だけを分母にした値。まだ実施していない授業は
// 「-」で、0% とは区別している。

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function AllClassesSummaryPane({ setErr, periodQuery = '' }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    (async () => {
      setBusy(true);
      try {
        const res = await fetch('/api/class-summary/all' + (periodQuery ? '?' + periodQuery : ''), {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        });
        const d = await res.json();
        if (!res.ok || d.success === false) throw new Error(d.error || d.message || '取得に失敗しました');
        setData(d);
      } catch (e) { setErr(e.message); }
      finally     { setBusy(false); }
    })();
  }, [periodQuery]); // eslint-disable-line

  if (busy)  return <div className="card"><p>読み込み中...</p></div>;
  if (!data) return <div className="card"><p style={{ color: '#888' }}>まとめを取得できませんでした。</p></div>;

  const ov = data.overview;
  const rateColor = (v) => (v == null ? '#888' : v < 60 ? '#dc2626' : v < 80 ? '#d97706' : '#16a34a');

  return (
    <>
      <div className="card">
        <div className="card-header"><h2>全体</h2></div>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-label">授業数</div>
            <div className="stat-value">{ov.class_count}<span className="stat-unit">件</span></div>
          </div>
          <div className="stat-card">
            <div className="stat-label">延べ履修者</div>
            <div className="stat-value">{ov.total_students}<span className="stat-unit">人</span></div>
          </div>
          <div className="stat-card">
            <div className="stat-label">延べ実施回数</div>
            <div className="stat-value">{ov.total_sessions}<span className="stat-unit">回</span></div>
          </div>
          <div className="stat-card">
            <div className="stat-label">平均出席率</div>
            <div className="stat-value">
              {ov.average_attendance_rate != null ? ov.average_attendance_rate : '-'}
              <span className="stat-unit">%</span>
            </div>
          </div>
        </div>
        {ov.low_attendance_count > 0 && (
          <p style={{ marginTop: '0.8rem', fontSize: '0.88rem' }}>
            連続欠席2回以上、または累計欠席3回以上の学生が
            <strong> {ov.low_attendance_count} </strong>件あります（授業ごとの延べ数）。
            <Link to="/students" style={{ marginLeft: '0.4rem' }}>学生管理で確認</Link>
          </p>
        )}
      </div>

      <div className="card">
        <div className="card-header"><h2>授業ごと（{data.classes.length}件）</h2></div>
        {data.classes.length === 0 ? (
          <p style={{ color: '#888' }}>授業がありません。</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="data-table">
              <thead>
                <tr>
                  <th>授業名</th><th>学期</th><th>履修者</th>
                  <th>実施</th><th>休講</th><th>平均出席率</th><th>要注意</th><th></th>
                </tr>
              </thead>
              <tbody>
                {data.classes.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.name}</strong></td>
                    <td style={{ whiteSpace: 'nowrap' }}>{c.semester || '-'}</td>
                    <td>{c.enrolled_students}人</td>
                    <td>{c.held_sessions}回</td>
                    <td>{c.cancelled_sessions > 0 ? c.cancelled_sessions + '回' : '-'}</td>
                    <td>
                      <strong style={{ color: rateColor(c.average_attendance_rate) }}>
                        {c.average_attendance_rate != null ? c.average_attendance_rate + '%' : '-'}
                      </strong>
                      {c.held_sessions === 0 && (
                        <div style={{ fontSize: '0.7rem', color: '#999' }}>未実施</div>
                      )}
                    </td>
                    <td>
                      {c.low_attendance_count > 0
                        ? <span style={{ color: '#dc2626', fontWeight: 700 }}>{c.low_attendance_count}人</span>
                        : '-'}
                    </td>
                    <td>
                      <Link className="btn-secondary" to={'/classes/' + c.id + '/summary'}>開く</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
